import cloudflareImageLoader from '@repo/platform-utils/image-loader';

export default cloudflareImageLoader;
